'use strict';

export function routeConfig($urlRouterProvider, $locationProvider) {
  'ngInject';

  //Forward application to contact
  $urlRouterProvider.when('/application', '/application/contact');
  $urlRouterProvider.when('/axby', '/axby/stats');

  $urlRouterProvider.otherwise('/');


  $locationProvider.html5Mode(true);
}



// WEBPACK FOOTER //
// ./client/app/app.config.js